<template>
    <div class="pantalla-single-product" v-if="this.product">
        <div  class="container-mob pb-0 w-100 container-single-product">

            <buscador-component></buscador-component>

            <div class="producto mt-4">
                <div class="text-end">
                    <a :href="'/?s='+this.product.serie.category_id" class="color-red pe-3">
                        <i class="fas fa-chevron-left"></i>
                    </a>
                </div>
                <h3 class="mb-2 text-white">{{ this.product.serie.main_category }}</h3>
                <div class="nombre-producto mb-2">
                    {{ this.product.nombre }}
                </div>
                <carousel :items="1" :nav="false">
                            <img v-for="imagen in this.product.imagenes" :src="'/storage/'+imagen" class="img-fluid slider-image mx-auto mb-4">
                </carousel>
                <div class="datos-header-producto d-flex">
                    <div class="corazon-single" @click="favoritoToggle()">
                        <span>
                            <i class="fa-heart" :class="this.product.favorito ? 'fas' : 'far'"></i>
                        </span>
                    </div>
                    <div class="precio-single">
                       {{ precioProducto }}
                        <i class="fas fa-tags"></i>
                    </div>
                </div>
            </div>

        </div>
            <div class="container-mob w-100">
                <table class="tabla-datos-producto" v-if="this.product !== null">
                    <tr v-for="atributo in this.product.atributos">
                        <td class="dato-titulo">
                            <span class="dato-producto">{{atributo.nombre}}</span>
                        </td>
                        <td>
                            <span class="color-red">{{atributo.pivot.valor}}</span>
                        </td>
                    </tr>

                </table>

            </div>

            <div class="botones-producto d-flex justify-content-between">
                <router-link :to="{ name: 'comparador', params: { producto_1: this.slug } }" class="btn btn-red" v-if="this.product.comparar !== null">
                    Comparar
                </router-link>
                <button class="btn btn-red" @click="goToCatalog()">
                    Ver en catálogo
                </button>
                <button class="btn btn-green" @click="addToPresupuesto()">
                    Añadir a presupuesto
                </button>
            </div>
            <menu-component></menu-component>
    </div>
</template>


<script>
export default {
    data() {
        return {
            slug: null,
            product: null,
            errors: null
        };
    },
    methods: {
        goToCatalog: function () {
            window.open(this.product.catalogo, '_blank');
        },
        favoritoToggle: function () {
            this.$store
            .dispatch("favoritoToggle", {id: this.product.id, value: !this.product.favorito})
            .then(response => {
                this.product.favorito = !this.product.favorito
            })
            .catch(error => {
                this.errors = error.response.data;
            });
        },
        addToPresupuesto: function () {
            this.$store
            .dispatch("addPresupuesto", {id: this.product.id})
            .then(response => {
                gtag('event', 'Añadir_Presupuesto', {
                    'producto_nombre': this.product.nombre,
                });
                this.$router.push({name: "presupuestos"});
            })
            .catch(error => {
                this.errors = error.response.data;
            });
        },
        potenciaProducto: function () {
            // `this` points to the vm instance
            if(this.product){
                var potencia = '';
                this.product.atributos.forEach(function(atributo) {
                    if (atributo.filtro_potencia ) {
                        potencia = atributo.pivot.valor
                    }
                });
                return potencia;
            }
        }
    },
    mounted: function () {
        this.slug = this.$route.params.slug;
        this.$store
        .dispatch("getProduct", {slug: this.slug})
        .then(response => {
            this.product = response.data;
            gtag('event', 'Ver_Producto_Gama_'+this.product.serie.main_category, {
                'producto_serie': 'Serie_'+this.product.serie.nombre,
                'producto_nombre': this.product.nombre,
                'producto_potencia': this.potenciaProducto()
            });
        })
        .catch(error => {
            this.errors = error.response.data;
        });


    },
    computed: {
        // a computed getter
        precioProducto: function () {
            // `this` points to the vm instance
            if(this.product){
                var precio = '';
                this.product.atributos.forEach(function(atributo) {
                    if (atributo.slug === 'pvr') {
                        precio = atributo.pivot.valor
                    }
                });
                return precio;
            }
        }
    }
};
</script>
